import { GetAvailableProductsResponseType } from 'QuoteApp/services/endpoints/GetAvailableProducts/types';

type AvailableProduct = GetAvailableProductsResponseType[number];

export const renderOperatingCompany = (availableProduct: AvailableProduct) => {
  const { carrierName, mga } = availableProduct.companyInfo;

  return [carrierName, mga].filter(Boolean).join(' and administered by ');
};
